import { ValidationProvider } from 'vee-validate';
import { Component } from 'vue-property-decorator';
import { ItiBaseEditor } from './../iti-base-editor';

@Component({
    components: {
        ValidationProvider,
    },
})
export default class ItiTextArea extends ItiBaseEditor {

}
